(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('orderProvider', OrderProvider)

    /** @ngInject */
    function OrderProvider(HelperService, PATHS) {
        function OrderProviderController() {
            const vm = this;

                        vm.getProductImage = product => {
                if (!product) return '';
                return HelperService.imageHandlerPath('product', product.Id, product.Image);
            };
        }

        return {
            bindToController: true,
            controller: OrderProviderController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/order-provider/order-provider.html`,
            scope: {
                provider: '=',
                unitId: '='
            }
        }
    }
}());